import store from "../store";

export default {
  itsBaronIT() {
    return store.getters.getUserCompany.emis == "baron-007";
  },
  appName() {
    return this.itsBaronIT() ? "BitsOffice" : store.getters.getUserCompany.name;
  },
  filterTiltes(tiles) {
    const tilesObj = tiles.filter((tileObj) => {
      return (
        tileObj.alevel.includes(Number(store.getters.getCurrentUser.alevel)) &&
        tileObj.industry.includes(store.getters.getUserCompany.industry)
      );
    });
    return tilesObj;
  },
};
